import React, { useMemo, useCallback } from 'react';
import { Search as SearchIcon } from '@mui/icons-material';
import SearchInput from '@src/new-components/SearchInput';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import { debounce } from 'lodash';

const Search = ({ setDataFilter, searchValueView, setSearchValueView }) => {
  const { t } = useTranslation();

  const debouncedHandleChangeFilter = useMemo(
    () =>
      debounce((value) => {
        setDataFilter((prev) => ({
          ...prev,
          search: value,
        }));
      }, 400),
    [setDataFilter],
  );

  React.useEffect(
    () => () => {
      debouncedHandleChangeFilter.cancel();
    },
    [debouncedHandleChangeFilter],
  );

  const handleInputChange = useCallback(
    (e) => {
      const { value } = e.target;
      setSearchValueView(value);
      debouncedHandleChangeFilter(value);
    },
    [setSearchValueView, debouncedHandleChangeFilter],
  );

  return (
    <SearchInput
      value={searchValueView}
      name="search"
      placeholder={t('searchVoiceByKeywords')}
      iconStart={
        <SearchIcon sx={{ fontSize: '24px', color: COLOR.navyBlue }} />
      }
      onChange={handleInputChange}
      styleInput={{ paddingLeft: '8px 12px' }}
      className="filter-search-input"
      placeholderStyle={{
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '20px',
        letterSpacing: '-0.4px',
        verticalAlign: 'middle',
        color: COLOR.descriptionGray,
      }}
    />
  );
};

export default Search;
